import { render } from "./account-number.vue?vue&type=template&id=dc9c762c&scoped=true&ts=true"
import script from "./account-number.vue?vue&type=script&lang=ts"
export * from "./account-number.vue?vue&type=script&lang=ts"

import "./account-number.vue?vue&type=style&index=0&id=dc9c762c&lang=less&scoped=true"
import "./account-number.vue?vue&type=style&index=1&id=dc9c762c&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9c762c"]])

export default __exports__